import {Theme} from '@mui/material';
/**
 * style object for ccf-navigation-items
 * @returns CcfNavigationItemsStyles styles object
 * ```
 * @example
 * <CcfNavigationItemsStyles/>
 * ```
 */
const CcfNavigationItemsStyles = (theme: Theme) => {
  const styles = {
    interactionSpaceResponsive: {
      [theme.breakpoints.up('xs')]: {
        minWidth: '92%',
        padding:'0px',
      },
    },
    contactHistoryResponsive: {
      [theme.breakpoints.up('xs')]: {
        ml: 0,
        position: 'relative',
      },
    },
  }
  return styles;
}

export default CcfNavigationItemsStyles;